import React from "react";
import { ShieldCheckIcon, LeafIcon, ClipboardCheckIcon, BadgeCheckIcon } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { Reveal } from "../ui/Reveal";
const safetyIcons = [ShieldCheckIcon, LeafIcon, ClipboardCheckIcon, BadgeCheckIcon];
export function SafetyQuality() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-256" data-mp="1utl3t4kkx2sk">
      <div className="max-w-content mx-auto px-4 sm:px-6" data-id="element-257" data-mp="2sdp9f4xr5ro2">
        <div className="grid lg:grid-cols-2 gap-8" data-id="element-258" data-mp="2ng5vy78vpix6">
          {/* Safety */}
          <Reveal data-id="element-259" data-mp="2ni9xwjn7w7ut">
            <div className="h-full rounded-sm bg-navy p-8 sm:p-10" data-id="element-260" data-mp="2ioxld7vtbrif">
              <span className="inline-flex items-center gap-2 text-orange font-semibold text-sm uppercase tracking-[0.18em]" data-id="element-261" data-mp="2in4afge62l4m">
                <span className="h-px w-6 bg-orange" aria-hidden="true" data-id="element-262" data-mp="3b58av7c4oxnz" />
                {t.safety.eyebrow}
              </span>
              <h2 className="mt-3 font-heading font-bold uppercase text-white text-3xl leading-[1.05]" data-id="element-263" data-mp="36dqiv8s327f5">
                {t.safety.safetyTitle}
              </h2>
              <ul className="mt-7 space-y-4" data-id="element-264" data-mp="3jxhgxefz07qd">
                {t.safety.safetyItems.map((item, i) => {
                const Icon = safetyIcons[i % safetyIcons.length];
                return <li key={item} className="flex items-start gap-4" data-id="element-265" data-mp="3b4xgc8g4bt2w" data-mpi={i}>
                      <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-orange/15 text-orange" data-id="element-266" data-mp="3b32somdgpmv4">
                        <Icon size={20} data-id="element-267" data-mp="316riq31ch93u" />
                      </span>
                      <span className="text-slate-200 leading-relaxed pt-1.5" data-id="element-268" data-mp="314wuaeqv6yv0">{item}</span>
                    </li>;
              })}
              </ul>
            </div>
          </Reveal>

          {/* Quality */}
          <Reveal delay={0.08} data-id="element-269" data-mp="lfbynzigelw8">
            <div className="h-full rounded-sm border border-slate-200 bg-slate-50 p-8 sm:p-10 flex flex-col" data-id="element-270" data-mp="lh6jldtq6e0b">
              <span className="inline-flex h-14 w-14 items-center justify-center rounded-sm bg-navy text-orange" data-id="element-271" data-mp="qeg90th46po5">
                <BadgeCheckIcon size={30} data-id="element-272" data-mp="ny6xo41vyyk3" />
              </span>
              <h2 className="mt-6 font-heading font-bold uppercase text-navy text-3xl leading-[1.05]" data-id="element-273" data-mp="jxn04zdehsxf">
                {t.safety.qualityTitle}
              </h2>
              <p className="mt-5 text-slate-600 leading-relaxed text-lg" data-id="element-274" data-mp="a0s4qpcfc8nd">
                {t.safety.qualityText}
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}